'use es6';

import { ACCOUNT_BUSINESS_UNIT_ID } from 'FormsCommonComponents/constants/BusinessUnits';
import * as Actions from 'FormsUI/actions/Dashboard';
import { LAST_THIRTY_DAYS } from 'foundations-components/transitional/components/Dates';
import { StateKeys } from 'FormsUI/constants/Dashboard';
import getDashboardDateRangeForUrlParams from 'FormsUI/utils/date/getDashboardDateRangeForUrlParams';
import { getDashboardDateRangeForPreset } from 'FormsUI/utils/date/getDashboardDateRangeForPreset';
import { getQueryParams } from 'FormsUI/utils/QueryParams';
export const INITIAL_STATE = {
  [StateKeys.FORM_ANALYTICS_DATE_RANGE]: getDashboardDateRangeForPreset(LAST_THIRTY_DAYS),
  [StateKeys.FORM_ANALYTICS_BUSINESS_UNIT_ID]: ACCOUNT_BUSINESS_UNIT_ID,
  [StateKeys.FORM_ANALYTICS_SELECTED_FORMS]: [],
  [StateKeys.FORM_ANALYTICS_SEARCH_QUERY]: ''
};
function receiveAnalytics(state) {
  return Object.assign({}, state, {
    [StateKeys.FORM_ANALYTICS_DATE_RANGE]: Object.assign({}, state[StateKeys.FORM_ANALYTICS_DATE_RANGE], getDashboardDateRangeForUrlParams(getQueryParams()))
  });
}
function changeAnalyticsDateRange(state, {
  range
}) {
  return Object.assign({}, state, {
    [StateKeys.FORM_ANALYTICS_DATE_RANGE]: range
  });
}
function changeAnalyticsSelectedForms(state, {
  formGuids
}) {
  return Object.assign({}, state, {
    [StateKeys.FORM_ANALYTICS_SELECTED_FORMS]: formGuids
  });
}
function changeAnalyticsSearchQuery(state, {
  query
}) {
  return Object.assign({}, state, {
    [StateKeys.FORM_ANALYTICS_SEARCH_QUERY]: query
  });
}
function changeAnalyticsBusinessUnitId(state, {
  businessUnitId
}) {
  return Object.assign({}, state, {
    [StateKeys.FORM_ANALYTICS_BUSINESS_UNIT_ID]: businessUnitId
  });
}
export function dashboard(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Actions.RECEIVE_ANALYTICS:
      return receiveAnalytics(state, action);
    case Actions.SET_ANALYTICS_DATE_RANGE:
      return changeAnalyticsDateRange(state, action);
    case Actions.SET_ANALYTICS_BUSINESS_UNIT_ID:
      return changeAnalyticsBusinessUnitId(state, action);
    case Actions.SET_ANALYTICS_SELECTED_FORMS:
      return changeAnalyticsSelectedForms(state, action);
    case Actions.SET_ANALYTICS_SEARCH_QUERY:
      return changeAnalyticsSearchQuery(state, action);
    default:
      return state;
  }
}